import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

/** Conferma di un'azione distruttiva (eliminazioni). */
const ConfirmDialog = ({ open, title, message, confirmLabel = 'Elimina', onConfirm, onClose, busy = false }) => (
  <Dialog open={Boolean(open)} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={busy}>Annulla</Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={busy}>{confirmLabel}</Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
